import script from "./ContactList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactList.vue?vue&type=script&setup=true&lang=js"

import "./ContactList.vue?vue&type=style&index=0&id=49e49cc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e49cc7"]])

export default __exports__